/* eslint-disable react/prop-types */
import './index.scss';
import { useState } from 'react';
import { ModalProps } from '../../../types';
import ModalBase from '..';
import ModalExecuteAction from '../ModalExecuteAction';
import { getCurrentDayYear, months } from '../../../helpers/utils/date';
import useHouseMoney from '../../../hooks/useHouseMoney';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { setHouseMoney } from '../../../store/slices/utils';

function ModalChangeRentDate({ modalIsOpen, setIsOpen, text, allowRender }: ModalProps) {
  if (allowRender === false) return null;

  const [showExecuteAction, setShowExecuteAction] = useState(false);
  const { handleHouseMoneyQuickAction, isLoading } = useHouseMoney();
  const walletsHouseMoney = useSelector((state: RootState) => state.wallets.houseMoney);

  const [, setRentDate] = useState<number>(months.indexOf(walletsHouseMoney?.withdrawalMonth));

  const dispatch = useDispatch();

  function closeModal() {
    setRentDate(-1);
    setIsOpen(false);
    setShowExecuteAction(false);
  }

  const actionExecuter = (password?: string) => {
    handleHouseMoneyQuickAction(
      closeModal,
      'edit_hm_withdraw_month',
      {
        rentDate: months.indexOf(walletsHouseMoney?.withdrawalMonth),
      },
      password,
    );
  };

  const ModalChildren = () => {
    const today = getCurrentDayYear();

    const onButtonClick = async (e: { preventDefault: () => void }) => {
      e.preventDefault();
      closeModal();
      setShowExecuteAction(true);
    };

    return (
      <div className={`modal-base general success action flex--4`}>
        <span onClick={closeModal}>&times;</span>

        <div className="change-rent-date">
          <h1 className="heading">Change Rent Date</h1>
          <p>Select a month</p>
          <div className="date-picker">
            <div className="month-select">
              {months.map((month: string, index: number) => {
                return (
                  <p
                    key={`${index}-${month}`}
                    onClick={() => {
                      const selectedMonth = month;
                      dispatch(
                        setHouseMoney({
                          ...walletsHouseMoney,
                          withdrawalMonth: selectedMonth,
                        }),
                      );
                    }}
                    className={months.indexOf(walletsHouseMoney?.withdrawalMonth) === index ? 'active' : ''}
                  >
                    {month}
                  </p>
                );
              })}
            </div>
          </div>
          <div className="button-container">
            <button
              disabled={months.indexOf(walletsHouseMoney?.withdrawalMonth) >= 0 ? false : true}
              onClick={onButtonClick}
            >
              Apply {months[months.indexOf(walletsHouseMoney?.withdrawalMonth)] || 'Rent Month'}{' '}
              {months.indexOf(walletsHouseMoney?.withdrawalMonth) >= 0
                ? months.indexOf(walletsHouseMoney?.withdrawalMonth) >= today.month
                  ? today.year
                  : today.year + 1
                : today.year}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
        <ModalChildren />
      </ModalBase>

      <ModalExecuteAction
        modalIsOpen={showExecuteAction}
        setIsOpen={setShowExecuteAction}
        text={text}
        action={(password: string) => actionExecuter(password)}
        isLoading={isLoading}
      />
    </>
  );
}

export default ModalChangeRentDate;
